import React from "react";
import { Container, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import LoginNavbar from "../Navbar/Navbar";
import toast, { Toaster } from 'react-hot-toast';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
function ForgetPassword() {
    const nav = useNavigate();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userx = useSelector(state => state.user);

    const [loading, setLoading] = useState(false);
    const [tfaForm, setTfaForm] = useState(false);
    const [tfaToken, setTfaToken] = useState("");
    const [form, setForm] = useState({
        login: "",
    })
    const [fgvalidation, setfgValidation] = useState({
        login: null,
    })
    const ResetPassword = async () => {

        if (loading) {
            return;
        }

        var initValidation = {
            login: null,
        }

        var errored = false;

        if (form.login === "") {
            initValidation.login = "Username must not be empty.";
            errored = true;
        }

        setfgValidation(initValidation);

        if (errored) {
            return;
        }

        setLoading(true);

        const response = await axios.post("https://managertime4betsaffiliate.com/api/manager/ForgotPassword", form);

        setLoading(false);

        if (response.data.Error == null) {
        }
    }

    return (
        <>
            <div style={{ maxHeight: 640, overflowY: "hidden" }} >
                <div>
                    <LoginNavbar />
                </div>
                <div>
                    <Container fluid className="d-flex justify-content-center mt-5 vh-100">
                        <div className="w-20" style={{ marginTop: 20 }}>
                            {" "}
                            <Form style={{ width: 250 }}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <input
                                        type="text"
                                        placeholder="Username"
                                        style={{
                                            borderRadius: "0",
                                            outline: "none",
                                            border: "1px solid grey",
                                            boxShadow: "none",
                                            marginBottom: "0rem",
                                            fontFamily: "sans-serif",
                                            height: 30,
                                            fontSize: 14,
                                            width:"100%"
                                        }}
                                        onChange={e => setForm({ ...form, login: e.target.value })}
                                        value={form.login}
                                        className={'form-control ' + (fgvalidation.login !== null ? "is-invalid" : "")}
                                    />
                                {
                                    fgvalidation.login !== null ? (
                                        <div class="invalid-feedback loginForm">
                                            {fgvalidation.login}
                                        </div>
                                    ) : (
                                        <></>
                                    )
                                }
                                </Form.Group>
                                <Button
                                    onClick={() => ResetPassword()}
                                    className="w-100"
                                    style={{
                                        backgroundColor: "#7eac2f",
                                        color: "#FFF",
                                        border: "none",
                                        borderRadius: "0",
                                        padding: "0.2rem",
                                        fontWeight: 500,

                                    }}
                                >
                                    Reset Password
                                </Button>
                            </Form>
                        </div>
                    </Container>
                </div>
            </div>
        </>
    );
}

export default ForgetPassword;
